import e from"./useThemeWithoutDefault.js";import t from"./createTheme/createTheme.js";const r=t();function o(t=r){return e(t)}export{o as default,r as systemDefaultTheme};
//# sourceMappingURL=useTheme.js.map
